import { writable, get } from 'svelte/store';
export default class DataProvider {
    constructor(options) {
        this._listEl = options.listEl;
        this._showSiteUrl = options.showSiteUrl;
        this._portalUrl = options.portalUrl;
        this._published = JSON.parse(options.published);
        this._order = writable('');
        this._orderDirection = writable('');
    }
    get listEl() {
        return this._listEl;
    }
    get showSiteUrl() {
        return this._showSiteUrl;
    }
    get portalUrl() {
        return this._portalUrl;
    }
    get published() {
        return this._published;
    }
    get order() {
        return get(this._order);
    }
    get orderDirection() {
        return get(this._orderDirection);
    }
}
